<template>
	<div id="switchItem">
		<div class="itemList">
<!--			<div class="item" v-for="i in 3" :key='i'>-->
<!--				<div class="banner">-->
<!--					<img src="../../assets/imgs/banner.jpeg" alt="">-->
<!--				</div>-->
<!--				<div class="info">-->
<!--					<div class="projectTheme">肺炎知识之光 全民科普行动 - 科普作品征集项目</div>-->
<!--					<div class="projectCycle">2025年05月 - 2025年09月</div>-->
<!--					<div class="projectInfo">-->
<!--						秋冬季节是呼吸道传染病的高发季，当前肺炎的发病情况呈现一定的上升趋势。《临床药物治疗杂志》杂志社发起“肺炎知识之光:全民科普行动科普作品征集项目”，全面科普肺炎的症状、传播途径、预防举措以及治疗方法等知-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->

      <div class="item"  v-for="(item,index) in dataList" :key='index' @click="toProject(item)">
        <div class="banner">
          <img :src="item.bannerPath "  alt="">
        </div>
        <div class="info">
          <div class="projectTheme">{{item.projectName}}</div>
          <div class="projectCycle">{{item.projectStartTime}} - {{item.projectEndTime}}</div>
          <div class="projectInfo" v-html="item.projectIntroduction">
          </div>
        </div>
      </div>
		</div>
		<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:current-page="queryForm.pageIndex" :page-sizes="pageSizes" :page-size="queryForm.pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total">
		</el-pagination>
	</div>
</template>

<script>
	import {selectProjectByPage} from "@/request/api";

  export default {
		name: 'switchItem',
		data() {
			return {
        dataList:[],
        queryForm:{
          pageIndex: 1,
          pageSize: 10
        },
				total: 0,
				pageSizes: [10, 20, 50]
			}
		},
		created() {
      this.queryData()
    },
		mounted() {},
		watch: {},
		methods: {
      toProject(item) {
        //本地记录 然后跳转到首页
        localStorage.setItem('projectId',item.projectId);
        localStorage.setItem('projectName',item.projectName);
        this.$router.push({
          path:'/'
        })
      },
      queryData(){
        selectProjectByPage(this.queryForm).then(res => {
          if (res.code == 200) {
            this.dataList = res.data.list;
            this.total=res.data.total;
            this.$forceUpdate()
          }
        })
      },
			// 每页数量发生变化
			handleSizeChange(val) {
				this.queryForm.pageSize = val
        this.queryData()
			},

			// 当前页发生变化
			handleCurrentChange(val) {
				this.queryForm.pageIndex = val
        this.queryData()
			}
		},
	}
</script>

<style lang="scss" scoped>
	#switchItem {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		width: 1300px;
		margin: auto;

		.itemList {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			width: 100%;
			padding: 20px 50px;
			margin-bottom: 30px;

			.item {
				display: flex;
				flex-direction: row;
				align-items: flex-start;
				width: 100%;
				margin: 20px 0;
				cursor: pointer;

				* {
					cursor: pointer;
				}

				.banner {
					width: 400px;
					height: 200px;
					border-radius: 10px;
					overflow: hidden;
					margin-right: 20px;

					img {
						display: block;
						width: 100%;
						height: 100%;
						object-fit: cover;
					}
				}

				.info {
					flex: 1;

					.projectTheme {
						font-size: 24px;
						color: #333#333;
						font-weight: 600;
						margin-bottom: 10px;
						text-align: justify;
					}

					.projectCycle {
						font-size: 14px;
						color: #999;
						margin-bottom: 10px;
					}

					.projectInfo {
						font-size: 14px;
						color: #666;
						text-align: justify;
					}
				}
			}
		}
	}
</style>